module.exports = __webpack_public_path__ + "img/coffee-5.0443f309.jpg";